import { DhCell, DhSym } from '@raketta/shared';

// Оригинальные SVG-символы для «Дома Псов» (нарисованы для проекта).
const D = '#0c1118';

const dogFace = (ears: string, col: string, snout: string) => (
  <g>
    <path d={ears} fill={col} />
    <circle cx="32" cy="34" r="16" fill={col} />
    <ellipse cx="32" cy="41" rx="8" ry="6" fill={snout} />
    <circle cx="25" cy="31" r="2.6" fill={D} />
    <circle cx="39" cy="31" r="2.6" fill={D} />
    <circle cx="32" cy="38" r="2.2" fill={D} />
  </g>
);

const letter = (ch: string, col: string) => (
  <g>
    <text x="32" y="44" textAnchor="middle" fontSize="40" fontWeight="900" fill={col} fontFamily="Inter, sans-serif">
      {ch}
    </text>
  </g>
);

function glyph(s: DhSym) {
  switch (s) {
    case 'wild': // будка-вывеска
      return (
        <g>
          <path d="M10 32L32 12l22 20z" fill="#ff5b3d" />
          <rect x="16" y="32" width="32" height="20" rx="2" fill="#e0a050" />
          <path d="M26 52V40h12v12z" fill="#5a3a1a" />
        </g>
      );
    case 'scatter': // лапа
      return (
        <g fill="#ffd24a">
          <circle cx="32" cy="40" r="11" />
          <circle cx="20" cy="28" r="4.5" />
          <circle cx="32" cy="22" r="4.5" />
          <circle cx="44" cy="28" r="4.5" />
        </g>
      );
    case 'h1':
      return dogFace('M19 20l2-11 9 7zM45 20l-2-11-9 7z', '#9fb0c4', '#fff'); // хаски
    case 'h2':
      return dogFace('M19 22l3-11 8 7zM45 22l-3-11-8 7z', '#e08a3c', '#fff'); // шиба
    case 'h3':
      return dogFace('M21 24l-4-8 8 4zM43 24l4-8-8 4z', '#d6b78a', '#3a2c1c'); // мопс
    case 'h4':
      return dogFace('M20 22l0-12 9 7zM44 22l0-12-9 7z', '#e0a050', '#fff'); // корги
    case 'l1':
      return letter('A', '#ff5b6e');
    case 'l2':
      return letter('K', '#ffd24a');
    case 'l3':
      return letter('Q', '#42d17a');
    case 'l4':
      return letter('J', '#36b9ff');
  }
}

export function DogSymbol({ cell, size = 48 }: { cell: DhCell; size?: number }) {
  return (
    <div className={`dh-sym ${cell.s === 'wild' ? 'wild' : ''} ${cell.sticky ? 'sticky' : ''}`}>
      <svg viewBox="0 0 64 64" width={size} height={size}>
        {glyph(cell.s)}
      </svg>
      {cell.s === 'wild' && cell.m ? <span className="dh-mult-badge">×{cell.m}</span> : null}
    </div>
  );
}
